import { useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import parse from 'html-react-parser';
import pages from '../content/pages.json';
import { siteOptions } from '../lib/siteRenderer';
import { applyPageMetadata, scrollToPageHash } from '../lib/pageEffects';
import { useMenuDismiss } from '../hooks/useDomEffects';
import { firmSchema, setContentSeo } from '../lib/contentSeo';

export default function SitePage() {
  const location = useLocation();
  const path = location.pathname.replace(/\/$/, '') || '/';
  const page = pages[path === '/home' ? '/' : path];
  useEffect(() => {
    if (!page) return;
    applyPageMetadata(page);
    setContentSeo({title: page.title, description: page.description, path: location.pathname, schema: firmSchema()});
    const timer = setTimeout(() => scrollToPageHash(location.hash), 40);
    return () => clearTimeout(timer);
  }, [page, location.hash, location.key, location.pathname]);
  useMenuDismiss();
  const content = useMemo(() => {
    if (!page) return null;
    return parse(page.html, siteOptions(path));
  }, [page, path]);
  if (!page) return <main className="site-not-found" data-testid="not-found-page"><h1 data-testid="not-found-heading">A different path forward.</h1><p data-testid="not-found-message">The page you’re looking for could not be found.</p><Link to="/practice-areas" data-testid="not-found-practice-link">Explore practice areas</Link><Link to="/" data-testid="not-found-home-link">Return to Home</Link></main>;
  return <div key={path}>{content}</div>;
}